import React from "react"
import cx from 'classnames'

import styles from './PostCategoryBadge.module.scss'

const PostCategoryBadge = ({ category, className } = {}) =>
  <span className={cx(className, styles.BlogCategory)}>{ category }</span>

export default PostCategoryBadge